import { bool, shape } from 'prop-types';
import React, { Component, Fragment } from 'react';
import AmpAccordion from 'components/AmpAccordion';
import Arrow from 'components/Icons/Arrow';
import NutritionalGuide from './NutritionalGuide';

class RecipeNutritionalGuide extends Component {
  constructor(props) {
    super(props);
    this.state = { isNutritionVisible: false };
    this.handleNutritionClick = this.handleNutritionClick.bind(this);
  }

  handleNutritionClick() {
    const { isNutritionVisible } = this.state;

    this.setState({ isNutritionVisible: !isNutritionVisible });
  }

  render() {
    const { nutritionalGuide, isAmp } = this.props;
    const { isNutritionVisible } = this.state;

    const onClick = e => {
      e.preventDefault();
      this.handleNutritionClick();
    };

    const gtmAttrs = {
      'data-gtm-nutrition-action': isNutritionVisible ? 'hide' : 'show'
    };

    return (
      <div className="RecipeNutritionalGuide">
        {isAmp ? (
          <Fragment>
            {nutritionalGuide && (
              <AmpAccordion>
                <Fragment>
                  <header>
                    <button className="button" type="button">
                      <span className="expand">Show</span>
                      <span className="close">Hide</span> Nutrition
                      <span className="expand">
                        <Arrow display="inline-block" rotate={90} />
                      </span>
                      <span className="close">
                        <Arrow display="inline-block" rotate={270} />
                      </span>
                    </button>
                  </header>
                  <div className="RecipeNutritionalGuide__amp-accordion">
                    <div className="RecipeNutritionalGuide__nutrition">
                      <NutritionalGuide {...nutritionalGuide} isAmp />
                    </div>
                  </div>
                </Fragment>
              </AmpAccordion>
            )}
          </Fragment>
        ) : (
          <Fragment>
            {nutritionalGuide && (
              <div className="RecipeNutritionalGuide__toggle">
                <button type="button" onClick={onClick} {...gtmAttrs}>
                  {isNutritionVisible ? 'Hide' : 'Show'} Nutrition{' '}
                  <Arrow
                    display="inline-block"
                    rotate={isNutritionVisible ? 270 : 90}
                  />
                </button>
              </div>
            )}
            {nutritionalGuide && (
              <div
                className="RecipeNutritionalGuide__nutrition"
                style={isNutritionVisible ? {} : { display: 'none' }}
              >
                <NutritionalGuide {...nutritionalGuide} />
              </div>
            )}
          </Fragment>
        )}
      </div>
    );
  }
}

RecipeNutritionalGuide.propTypes = {
  nutritionalGuide: shape(NutritionalGuide.propTypes),
  isAmp: bool
};

RecipeNutritionalGuide.defaultProps = {
  nutritionalGuide: undefined,
  isAmp: false
};

export default RecipeNutritionalGuide;
